import * as React from 'react';

export interface DVUIContext {}
export const defaultDVUIContext: DVUIContext = {
    // Add all data, weblabs, strings that DVUI components need to render
};

const { Provider, Consumer } = React.createContext(defaultDVUIContext);

const DVUIOverride: React.Provider<DVUIContext> = (props) => (
    <Consumer>{(context) => <Provider value={{ ...context, ...props.value }}>{props.children}</Provider>}</Consumer>
);

export { DVUIOverride, Consumer as DVUIConsumer };
